interface Colors {
  [key: string]: string;
}

const colors: Colors = {
  // Worldline
  masterMint: '#45beab',
  masterMint600: '#149990',
  coolCoconut: '#ffffff',
  perfectPepper: '#000000',
  sureSage: '#2d8d8c',
  boldBlueberry: '#42b4d2',
  reliableRhubarb: '#f08890',
  confidentCorn: '#ffeb78',
  friendlyFig: '#005a8b',
  grey: '#5b5b5b',
  lightGrey: '#e2e2e2',
  lighterLightGrey: '#eeeeee',

  // Extra
  lightGreen: '#3cc47c',
  pastelGreen: '#E4F6E2',
  rawGreen: '#028321',
  darkGreen: '#003533',
  darkAltGreen: 'rgb(31 53 45)',
  azure11: '#0F172B',
  azure27: '#314158',
  azure33: '#0069A8',
  azure34: '#4A5565',
  azure35: '#45556C',
  azure46: '#6A7282',
  azure47: '#62748E',
  azure54: '#155DFC',
  azure65: '#90A1B9',
  azure84: '#CAD5E2',
  azure86: '#B8E6FE',
  green01100: '#D6FFE5',
  green01200: '#6BD6BF',
  green01400: '#277777',
  green01600: '#226969',
  green01700: '#1c5858',
  green30: '#009966',
  beige: '#e9c893',
  darkGrey: '#828081',
  grey01100: '#F7F8FC',
  grey01200: '#dfdfe6',
  grey01300: '#575665',
  grey013002: '#C8C8CF',
  grey01400: '#d9d9d9',
  grey01500: '#8B8B9A',
  grey01700: '#464552',
  grey01800: '#32313B',
  grey01900: '#232229',
  grey02600: '#4A4C4C',
  grey02500: '#555858',
  grey02300: '#989C9C',
  grey10: '#1a1a1a',
  grey91: '#E2E8F0',
  grey92: '#E9D4FF',
  grey93: '#DBEAFE',
  grey94: '#DFF2FE',
  grey95: '#F3E8FF',
  grey97: '#F1F5F9',
  grey98: '#f8fafc',
  gray100: '#F3F4F6',
  gray400: '#99A1AF',
  gray500: '#6b7280',
  neutralBakcground: '#F5F6FA',
  neutralRowsBG: '#fafafa',
  red: '#e24e42',
  red51: '#DC2626',
  red01100: '#FFF2F5',
  red01200: '#ffdbdc',
  red01300: '#FFBBC3',
  red01700: '#C24C65',
  red01900: '#d81b2f',
  red02000: '#aa2f4f',
  violet43: '#8200DB',
  yellow: '#e9b000',
  purple: '#431c5d',
  purple01200: '#7850B4',
  white: '#ffffff',
  black: '#000000',
  dark: '#222222',
  borderColor: '#efefef',
  textGrey: '#575665',
  darkMint: '#007B7C',
  pastelMint: '#E3F5F2',
  orange: '#DB6A00',
  orange01400: '#E15A46',
  lightMint: '#e5fbfa',
  blue01700: '#10719E',
  transparentBlack: 'rgba(0, 0, 0, 0.5)',
  semanticTextBlack: 'rgba(0, 0, 0, 0.87)',
  semanticTextDisabled: 'rgba(0, 0, 0, 0.3)',
  semanticLightBackground: 'rgba(0, 0, 0, 0.05)',
  semanticBgGray: '#F8F8F9',
  semanticRed: '#F08791',
  semanticBorderFocused: '#96C8DA',
  semanticBorder: 'rgba(34, 36, 38, 0.15)',
  inkeepBrandColor: 'rgb(70, 190, 170)',
  inkeepBrandColorFaded: 'rgb(70, 190, 170, 0.5)',
};

// Function to convert hex to RGBA
export function hexToRGBA(hex: string, alpha = 1) {
  hex = hex.replace(/^#/, '');
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export default colors;
